/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import { useMemo } from 'react';
import Bar from './Bar';
import Pie from './Pie';
import Line from './Line';
import Value from './Value';
import Radar from './Radar';
import Map from './Map';
import Funnel from './Funnel';
import RadialBar from './RadialBar';
import Table from './Table';
import Calendar from './Calendar';
import Waffle from './Waffle';
import BoxPlot from './BoxPlot';
import ScatterPlot from './ScatterPlot';
import SubsetTable from './SubsetTable';
import Histogram from './Histogram';
import Pareto from './Pareto';
import Bullet from './Bullet';
import Gauge from './Gauge';

import getDefaultStyle, { legacyRemap } from '../utils/chartTools/getDefaultStyle';

const chartGallery = {
  Bar,
  Pie,
  Line,
  Value,
  Radar,
  Map,
  Funnel,
  RadialBar,
  Table,
  Calendar,
  Waffle,
  BoxPlot,
  ScatterPlot,
  SubsetTable,
  Histogram,
  Pareto,
  Bullet,
  Gauge,
};

function getChart(type) {
  return chartGallery[type] || null;
}

const Chart = ({
  type,
  data,
  styleConfig,
  kpiSize,
  handleStyleConfig,
  isEdit,
  valueFunction,
  globalConfig,
  handleDrilldownClick,
}) => {
  const Component = getChart(styleConfig?.type || type);
  const style = useMemo(() => (
    { ...getDefaultStyle(styleConfig?.type || type), ...legacyRemap(styleConfig) }
  ), [styleConfig, type]);
  return (Component) ? (
    <Component
      data={data}
      styleConfig={style}
      kpiSize={kpiSize}
      handleStyleConfig={handleStyleConfig}
      handleDrilldownClick={handleDrilldownClick}
      isEdit={isEdit}
      valueFunction={valueFunction}
      globalConfig={globalConfig}
    />
  ) : null;
};

export default Chart;
